/**
 * External Dependencies
 */
import 'jquery';
import './slick/slick.min.js';

$(document).on('ready', function () {

    pageHeight();
    cookieConsentAdjust();
    replaceSvg();
    deviceHeight();
    menuHeight();
    headerHeight();

    $(window).on('resize', function () {
        pageHeight();
        deviceHeight();
        menuHeight();
        headerHeight();
    });

    /* SKIPLINK */
    $('.skiplink').find('a').on('focusin', function () {
        $('.skiplink').addClass('skiplink--expanded');
    }).on('focusout', function () {
        $('.skiplink').removeClass('skiplink--expanded');
    });

    /* ANCHOR LINK SMOOTH SCROLL */
    $('a:not(.modal-cacsp-btn, .modal-cacsp-toggle-switch)[href^="#"]').on('click', function (e) {

        if ($.attr(this, 'href') != '#cookiesAndContentPolicySettings') {
            const doc = document.documentElement;
            const offset = doc.style.getPropertyValue('--header-height');

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - parseInt(offset),
            }, 300);
        }

        return;
    });

    /* CUSTOM CURSOR */
    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $('.at-cursor').length > 0) {
        var xPos = 0;
        var yPos = 0;
        var lastScrolled = 0;

        $(document).on('mousemove', function (event) {
            xPos = event.pageX;
            yPos = event.pageY;
            $('.at-cursor').css({ top: yPos + 'px', left: xPos + 'px' });
        }).on('scroll', function () {
            if (lastScrolled != yPos) {
                yPos -= lastScrolled;
                lastScrolled = $(document).scrollTop();
                yPos += lastScrolled;

                $('.at-cursor').css({ top: yPos + 'px' });
            }
        });
    }

    /* HAMBURGER MENU */
    $('.hamburger__toggle').on('click', function () {
        $(this).toggleClass('hamburger__toggle--open');
        $('.navigation__container').toggleClass('navigation__container--active');
        $('body').toggleClass('body--lightbox');
    });

    /* INPUT WCAG FOCUS */
    $('input:not([type="submit"]), textarea, select').on('keyup', function (e) {
        if (e.key === 'Tab') {
            $(this).addClass('focus-visible');
        }
    }).on('focusout', function () {
        $(this).removeClass('focus-visible');
    });

    /* CUSTOM INPUT STYLES */
    $('.wpcf7-form-control').find('input[type="checkbox"]').on('click', function () {
        if ($(this).is(':checked')) {
            $(this).closest('label').addClass('checked');
        } else {
            $(this).closest('label').removeClass('checked');
        }
    });

    $('.wpcf7-form-control-wrap').find('input[type="file"]').on('change', function (e) {
        e.preventDefault();

        if ($(this)[0].files[0] || $(this)[0].files.length > 0) {
            $(this).addClass('filled');
            $(this).parent().addClass('filled');
            $(this).attr('data-file', $(this)[0].files[0].name);
        } else {
            $(this).removeClass('filled');
            $(this).parent().removeClass('filled');
            $(this).attr('data-file', 'Klicka eller dra och släpp din fil här');
        }
    });

    $('.wpcf7-form-control-wrap').find('input[type="file"]').attr('data-file', 'Klicka eller dra och släpp din fil här');

    $('.wpcf7-form-control-wrap').find('input[type="file"]').parent().append(`<button aria-label="Ta bort fil" type="button" class="wpcf7-remove-file btn btn--solid btn--solid--black rounded-full text-sm"><span class="btn__icon bg-none fa-solid fa-xmark"></span></button>`);

    $('.wpcf7-remove-file').on('click', function () {
        const input = $(this).siblings('input[type="file"]')[0];
        input.value = '';

        if (!input.files[0] || input.files.length <= 0) {
            $(input).removeClass('filled');
            $(input).parent().removeClass('filled');
            $(input).attr('data-file', 'Klicka eller dra och släpp din fil här');
        }

        $(input).trigger('change');
    });

    /* FOCUS ELEMENT IN VIEWPORT */
    if ($('.at-bar').length > 0) {
        $('*').on('focus', function () {

            if ($('.at-bar').has(this).length > 0) {
                return;
            }

            const viewportTop = $(window).scrollTop();
            const viewportHeight = $(window).height();
            const viewportBottom = viewportTop + viewportHeight - 112;

            const offset = $(this).offset();
            const height = $(this).height();
            const elementBottom = offset.top + height;
            const position = offset.top + height - viewportHeight + 160;

            if (elementBottom > viewportBottom) {
                $('html, body').animate({
                    scrollTop: position,
                }, 300);
            }
        });
    }

    /* EDUCATION BOOKING FORM */
    $('.education-booking-btn').on('click', function () {
        $('.education-content').removeClass('education-content--active');
        $('.education-booking').addClass('education-booking--active');

        $('html, body').animate({
            scrollTop: 0,
        }, 0);
    });

    $('.education-content-btn').on('click', function () {
        $('.education-booking').removeClass('education-booking--active');
        $('.education-content').addClass('education-content--active');

        $('html, body').animate({
            scrollTop: 0,
        }, 0);
    });

    /* EDUCATION STICKY MENU */
    $('.education-header__nav__item > a').on('click', function (e) {
        e.preventDefault();

        $(this).parent().addClass('active');
        $('.education-header__nav__item').not($(this).parent()).removeClass('active');
    });

    /* CAREER APPLICATION FORM */
    $('.career-application-btn').on('click', function () {
        $('.career-content').removeClass('career-content--active');
        $('.career-application').addClass('career-application--active');

        $('html, body').animate({
            scrollTop: 0,
        }, 0);
    });

    $('.career-content-btn').on('click', function () {
        $('.career-application').removeClass('career-application--active');
        $('.career-content').addClass('career-content--active');

        $('html, body').animate({
            scrollTop: 0,
        }, 0);
    });

    /* CAREER APPLICATION OVERVIEW */
    $('.career-application').find('.wpcf7-form-control-wrap').find('input, textarea').on('change', function () {
        setOverview($(this));
    });

    /* ACCORDION */
    if ($('.at-accordion__item--open').length > 0) {
        $('.at-accordion__item--open').each(function (i, accordion) {
            const content = $(accordion).find('.at-accordion__item__content');
            const height = content.find('.at-accordion__item__content__inner')[0].scrollHeight;

            content.height(height + 'px');
        });
    }

    $('.at-accordion__item__toggle').on('click', function (e) {
        e.preventDefault();
        const accordion = $(this).parent('.at-accordion__item');
        const content = $(this).siblings('.at-accordion__item__content');
        const height = content.find('.at-accordion__item__content__inner')[0].scrollHeight;

        if (accordion.hasClass('at-accordion__item--open')) {
            accordion.removeClass('at-accordion__item--open');
            content.height('0px');

            if ($(accordion).find('.at-accordion__item__content__inner__media__animation').length > 0) {
                setTimeout(function () {
                    $(accordion).find('.at-accordion__item__content__inner__media__animation')[0].stop();
                }, 300);
            }
        } else {
            accordion.addClass('at-accordion__item--open');
            content.height(height + 'px');

            if ($(accordion).find('.at-accordion__item__content__inner__media__animation').length > 0) {
                $(accordion).find('.at-accordion__item__content__inner__media__animation')[0].play();
            }
        }
    });

    /* FILTER ARCHIVE */
    $('.at-filter').on('click', function (e) {
        filterArchive(e);
    });

    /* IMAGE PARALLAX ON SCROLL */
    if ($('.animation-parallax').length > 0) {
        imageParallax();
    }

    /* BANNER PARALLAX ON SCROLL */
    if ($('.animation-banner').length > 0) {
        bannerParallax();
    }

    /* ANIMATION ON SCROLL */
    if ($(window).width() >= 1024) {
        scrollAnimation();

        $(window).on('scroll', function () {
            scrollAnimation();
        });
    }

});

/* FUNCTIONS */
function pageHeight() {
    const footerHeight = $('footer').outerHeight();
    const windowHeight = $(window).height();

    $('main').css('min-height', (windowHeight - footerHeight) + 'px');
}

function deviceHeight() {
    const doc = document.documentElement;
    doc.style.setProperty('--device-height', `${window.innerHeight}px`);
}

function menuHeight() {
    const doc = document.documentElement;
    doc.style.setProperty('--menu-height', `${window.innerHeight}px`);
}

function headerHeight() {
    const doc = document.documentElement;
    doc.style.setProperty('--header-height', `${$('header').outerHeight() - 1}px`);
}

function cookieConsentAdjust() {

    $('.modal-cacsp-box').find('a').attr('tabindex', 1);

    if ($('.cc-blockingScreen').length && $('.cc-blockingScreen').is(':visible') && $('.cc-window').length && !$('.cc-window').is(':visible')) {
        $('.cc-window').removeClass('cc-invisible');
        $('.cc-window').addClass('cc-visible');
    }

    $('.cc-window .cc-compliance').prepend('<button class="cc-btn" id="avantime-settings">Anpassa urval</button>');

    $('.cc-window .cc-compliance #avantime-settings').on('click', function () {
        $('.cc-window .cc-allswitches').addClass('active');
        $(this).remove();
        $('.cc-window .cc-compliance .cc-savesettings').addClass('active');
    });
}

function replaceSvg() {
    $('.inline-svg').each(function () {
        let $img = $(this);
        let imgClass = $img.attr('class');
        let imgURL = $img.attr('src');

        $.get(imgURL, function (data) {
            // Get the SVG tag, ignore the rest
            let $svg = $(data).find('svg');

            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');
            let children = $svg.find('*');

            $.each(children, function (index, child) {

                if (child.getAttribute('fill') != null) {
                    $(child).addClass('fill');
                } else {
                    $(child).addClass('stroke');
                }
            });

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');

    });
}

function setOverview(input) {
    const type = input[0].type;
    const field = input.attr('name');

    if (type === 'checkbox' && (field === 'kontor[]' || field === 'kontor')) {
        const overview = $('#kontor').find('p');
        const currentValue = overview.text();

        if (currentValue != '-') {
            if (input.is(':checked')) {
                overview.text(currentValue + ', ' + input[0].value);
            } else {
                if (currentValue.indexOf(', ') != -1) {
                    let newValue = currentValue.replace(', ', '');

                    overview.text(newValue.replace(input[0].value, ''));
                } else {
                    overview.text('-');
                }
            }
        } else {
            if (input.is(':checked')) {
                overview.text(input[0].value);
            }
        }
    }

    if (type === 'file' && (field === 'ditt-cv' || field === 'ditt-dokument')) {
        if (input[0].files[0] || input[0].files.length > 0) {
            $('#' + field).find('p').text('Tillagt');
        } else {
            $('#' + field).find('p').text('-');
        }
    }

    if (type === 'text' || type === 'email' || type === 'tel' || type === 'url') {
        if (input[0].value != '') {
            $('#' + field).find('p').text(input[0].value);
        } else {
            $('#' + field).find('p').text('-');
        }
    }

    if (field === 'ditt-meddelande') {
        if (input[0].value != '') {
            $('#' + field).find('p').text('Tillagt');
        } else {
            $('#' + field).find('p').text('-');
        }
    }
}

/* ANIMATION */
const animationClasses = [
    'animation-fade-in',
    'animation-fade-up',
    'animation-fade-down',
    'animation-fade-right',
    'animation-fade-left',
    'animation-slide-up',
    'animation-slide-down',
    'animation-slide-right',
    'animation-slide-left',
    'animation-counter',
];

function isElementInViewport(element, elementClass) {
    let animatedElement = $(element);
    let animatedClass = elementClass;

    // Get viewport size
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    // Get scroll position of the element
    const elemTop = Math.round($(animatedElement).offset().top);

    if (elemTop < viewportBottom) {

        /* KEYNUMBER ANIMATION */
        if ($(animatedElement).hasClass('animation-counter') && !$(animatedElement).hasClass(animatedClass + '--active')) {

            $(animatedElement).find('.keynumber__number').each(function (key, number) {

                $({ Counter: 0 }).animate({
                    Counter: $(number).text(),
                }, {
                    duration: 2000,
                    easing: 'swing',
                    step: function () {
                        $(number).text(Math.ceil(this.Counter));
                    },
                });
            });
        } /* End of KEYNUMBER ANIMATION */

        $(animatedElement).addClass(animatedClass + '--active');
    }
}

function scrollAnimation() {

    for (let i = 0; i < animationClasses.length; i++) {
        const animationClass = animationClasses[i];
        const elements = $('.' + animationClass);

        elements.each(function (index, element) {
            if (!$(element).hasClass(animationClass + '--active')) {
                isElementInViewport(element, animationClass);
            }
        });
    }
}

/* IMAGE PARALLAX */
function imageParallax() {
    const parallaxElements = $('.animation-parallax');
    let lastScrollTop = 0;

    jQuery(window).on('scroll', function () {

        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();
        const current = jQuery(window).pageYOffset || document.documentElement.scrollTop;

        parallaxElements.each(function (i, element) {

            const parallaxTop = Math.round($(element).offset().top);
            const parallaxBottom = parallaxTop + $(element).height();
            let position = $(element).data('position');

            if (current > lastScrollTop) {

                if ($(window).width() >= 1024) {
                    position += 0.02;
                } else {
                    position += 0.01;
                }

            } else if (current < lastScrollTop) {
                if ($(window).width() >= 1024) {
                    position -= 0.02;
                } else {
                    position -= 0.01;
                }
            }

            if (parallaxTop < viewportBottom && parallaxBottom > viewportTop) {
                $(element).css({ transform: 'translate3d(0px, ' + position + '%, 0px) scale3d(1.15, 1.15, 1)' });
                $(element).data('position', position);
            }
        });

        lastScrollTop = current <= 0 ? 0 : current;
    });
}

/* BANNER PARALLAX */
function bannerParallax() {
    const parallaxElements = $('.animation-banner');
    let lastScrollTop = 0;

    jQuery(window).on('scroll', function () {

        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();
        const current = jQuery(window).pageYOffset || document.documentElement.scrollTop;

        parallaxElements.each(function (i, element) {

            const parallaxTop = Math.round($(element).offset().top);
            const parallaxBottom = parallaxTop + $(element).height();
            let position = $(element).data('position');

            if (current > lastScrollTop) {
                position -= 0.1;
            } else if (current < lastScrollTop) {
                position += 0.1;
            }

            if (parallaxTop < viewportBottom && parallaxBottom > viewportTop) {
                $(element).css({ transform: 'translate3d(' + position + '%, 0px, 0px)' });
                $(element).data('position', position);
            }
        });

        lastScrollTop = current <= 0 ? 0 : current;
    });
}

/* FILTER ARCHIVE */
function filterArchive(e) {

    let type = null;

    if ($(e.target).hasClass('at-filter--case')) {
        type = 'case';
    } else {
        type = 'news';
    }

    if (!type) {
        return;
    }

    const category = $(e.target).data('filter');

    $.ajax({
        type: 'POST',
        url: window.sage.ajax_url,
        dataType: 'json',
        data: {
            action: type === 'case' ? 'filter_case' : 'filter_news',
            kategori: category,
            nonce: window.sage.nonce,
        },
        success: function (res) {
            $(e.target).siblings('.at-filter').removeClass('at-filter--active');
            $(e.target).addClass('at-filter--active');
            $('.at-archive__list').html(res.html);

            if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                jQuery('.at-archive .at-archive__list__item__link').on('mouseenter', function () {
                    jQuery('.at-cursor').removeClass('at-cursor--hidden');
                    jQuery('.at-cursor').addClass('at-cursor--active');
                }).on('mouseleave', function () {
                    jQuery('.at-cursor').removeClass('at-cursor--active');
                    jQuery('.at-cursor').addClass('at-cursor--hidden');
                });
            }
        },
    });
}
